import { Form, Formik } from 'formik'
import React from 'react'
import Input from './componentsFinance/common/Input'
import Button from './componentsFinance/common/Button'

export default function IncomeQuarterlyForm({ onSubmit, onCancel, loading, initialValues }) {
    return (
        <Formik initialValues={{ date: '', quarter: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    name="quarter"
                    label="Название Четверть"
                    disabled={loading}
                    placeholder="" />

                <Input
                    type="date"
                    name="date"
                    label="Дата"
                    disabled={loading}
                    placeholder="" />
                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
